// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___hBCM9","root__title":"style-module__root__title___bRDoo","root__top":"style-module__root__top___R1HVh","root__bottom":"style-module__root__bottom___vuleI","root__button":"style-module__root__button___A2zBR"};
    if(module.hot) {
      // 1697460471985
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  